import { Question } from './question.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class OpenQuestion extends Question {
  public static fromDto(dto: any): OpenQuestion {
    const question: OpenQuestion = new OpenQuestion();
    Question.mapBaseProperties(question, dto);
    return question;
  }
}
